import React from 'react';
import { FormMap, Props } from './form.type';
import Contact from './contact/Contact';
import Institution from './institution/Institution';
import Verification from './verification/Verification';

function InstitutionForm({ mode }: Props) {
  const formMap: FormMap = {
    contact: <Contact />,
    institution: <Institution />,
    verify: <Verification />
  };

  return formMap[mode];
}

export default InstitutionForm;
